interface InfoSectionProps {
  title: string;
  items: {
    text: string;
    url: string;
  }[];
}

export function InfoSection({ title, items }: InfoSectionProps) {
  return (
    <section>
      <div className="bg-white rounded-lg border border-neutral-200 shadow-soft p-6">
        <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 text-center mb-6">
          {title}
        </h2>
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li key={index} className="flex items-start">
              <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-700 font-medium underline decoration-primary-300 hover:decoration-primary-500 transition-colors font-body"
              >
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}